import Vue from 'vue'

import Topbar from './Topbar.vue'
import Sidebar from './Sidebar.vue'
import Footer from './Footer.vue'

Vue.component('fs-topbar', Topbar)
Vue.component('fs-sidebar', Sidebar)
Vue.component('fs-footer', Footer)
